var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralPractitionerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 44.967,
    viewBox: "0 0 32.5 44.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free_trial",
    transform: "translate(-3.5 -0.535)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y2: 6.1,
    transform: "translate(19.75 4.993)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 6.1,
    transform: "translate(16.7 8.043)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M31.17,14.359a1.937,1.937,0,0,1,.409-.049,2.579,2.579,0,0,1,2.344,2.763,2.579,2.579,0,0,1-2.344,2.763,2.065,2.065,0,0,1-1.22-.413c-1.732,5.671-7.383,11.389-10.972,11.389s-9.239-5.718-10.97-11.389a2.09,2.09,0,0,1-1.222.413,2.579,2.579,0,0,1-2.344-2.763A2.579,2.579,0,0,1,7.2,14.31a1.937,1.937,0,0,1,.409.049",
    transform: "translate(0.363 13.2)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M10.158,18.645A4.358,4.358,0,0,0,13.9,20.5a4.358,4.358,0,0,0,3.745-1.85",
    transform: "translate(5.847 17.68)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M19.819,18.893c.1-.283.191-.575.274-.874a12.934,12.934,0,0,0,.5-3.505,13.123,13.123,0,0,0-2.151-7.186",
    transform: "translate(14.407 5.985)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M6.623,7.35A13.115,13.115,0,0,0,4.5,14.489,12.934,12.934,0,0,0,5,17.995",
    transform: "translate(0 6.008)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M12,9.464",
    transform: "translate(7.75 8.193)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M6.779,18.5q-2.275,2.074-1.8,3.221c.331.793,1.464.819,1.8,1.61q.479,1.15-1.8,3.221",
    transform: "translate(0.413 17.534)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M18.218,18.5q2.275,2.074,1.8,3.221c-.331.793-1.464.819-1.8,1.61q-.479,1.15,1.8,3.221",
    transform: "translate(14.09 17.534)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M32.079,16.255q-2.663.259-5.4.262C10.922,16.517,9.936,9.88,9.936,9.88s.331,5.268-3.359,5.268",
    transform: "translate(2.146 8.623)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    y2: 2.033,
    transform: "translate(14.667 27.824)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    y2: 2.033,
    transform: "translate(24.833 27.824)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M27.333,8.779A48.339,48.339,0,0,0,7,8.779",
    transform: "translate(2.583 6.368)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M8.738,14.1,5.93,7a1.85,1.85,0,0,1,.521-2.084c5.047-4.51,18.865-4.51,23.912,0A1.85,1.85,0,0,1,30.883,7l-2.808,7.1",
    transform: "translate(1.343 0)",
    fill: "none",
    stroke: "#df7467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralPractitionerIcon);
export default __webpack_public_path__ + "static/media/general_practitioner_icon.91b13268f81f1e47f5fa3189dd25fdb0.svg";
export { ForwardRef as ReactComponent };